exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category[data-v-6cb99e7c]{color:var(--black-light-5)}.separator[data-v-6cb99e7c]{margin-bottom:32px;margin-top:32px}@media(min-width:601px){.marine-focus[data-v-6cb99e7c]{grid-column-start:1;grid-column-end:3}}", ""]);

// exports
